import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settingsandpermissions',
  templateUrl: './settingsandpermissions.component.html',
  styleUrls: ['./settingsandpermissions.component.scss']
})
export class SettingsAndPermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
